export function mapPrintOperator(node, ctx) {
    const listNode = ctx.getChild(node, "ProjectItemList");
    if (listNode) {
        // ProjectItemList -> Identifier (Comma Identifier)*
        // Grammar may eventually expand to expressions; keep placeholder logic.
    }
    return {
        type: "PrintOperator",
        expressions: [],
        start: node.from,
        end: node.to,
    };
}
